const U = (id) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=900&q=80`;
const P = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=900`;

export const FESTIVALS = [
  { slug: "diwali", name: "Diwali", desc: "The festival of lights, gilded.", img: P("6120397") },
  { slug: "holi", name: "Holi", desc: "Colour, joy and sweet beginnings.", img: U("1576089172869-4f5f6f315620") },
  { slug: "raksha-bandhan", name: "Raksha Bandhan", desc: "For the bond that protects.", img: P("14107") },
  { slug: "dussehra", name: "Dussehra", desc: "Victory, celebrated grandly.", img: P("10189993") },
  { slug: "navratri", name: "Navratri", desc: "Nine nights of devotion.", img: P("6120397") },
  { slug: "bhai-dooj", name: "Bhai Dooj", desc: "Siblings, sealed with sweetness.", img: P("10189993") },
  { slug: "karwa-chauth", name: "Karwa Chauth", desc: "A fast kept with love.", img: U("1524592094714-0f0654e20314") },
  { slug: "eid", name: "Eid", desc: "Generosity, beautifully boxed.", img: P("20699854") },
  { slug: "christmas", name: "Christmas", desc: "Warmth wrapped in gold.", img: U("1512389142860-9c449e58a543") },
  { slug: "new-year", name: "New Year", desc: "Begin the year memorably.", img: P("14107") },
  { slug: "makar-sankranti", name: "Makar Sankranti", desc: "Harvest sweetness to share.", img: P("20699855") },
  { slug: "lohri", name: "Lohri", desc: "Bonfires and winter warmth.", img: P("20699854") },
  { slug: "pongal", name: "Pongal", desc: "Gratitude from the harvest.", img: P("20699855") },
  { slug: "onam", name: "Onam", desc: "A feast of prosperity.", img: P("10189993") },
  { slug: "baisakhi", name: "Baisakhi", desc: "Abundance, celebrated.", img: P("20699854") },
  { slug: "ganesh-chaturthi", name: "Ganesh Chaturthi", desc: "Auspicious new beginnings.", img: P("10189993") },
  { slug: "janmashtami", name: "Janmashtami", desc: "Devotion, delightfully gifted.", img: P("6120397") },
];

export const OCCASIONS = [
  { slug: "birthday", name: "Birthday", img: U("1464349153735-7db50ed83c84") },
  { slug: "anniversary", name: "Anniversary", img: U("1519741497674-611481863552") },
  { slug: "wedding", name: "Wedding", img: U("1519741497674-611481863552") },
  { slug: "engagement", name: "Engagement", img: U("1526047932273-341f2a7631f9") },
  { slug: "housewarming", name: "Housewarming", img: U("1600585154340-be6161a56a0c") },
  { slug: "baby-shower", name: "Baby Shower", img: U("1519689680058-324335c77eba") },
  { slug: "graduation", name: "Graduation", img: P("14107") },
  { slug: "retirement", name: "Retirement", img: U("1434056886845-dac89ffe9b56") },
  { slug: "thank-you", name: "Thank You", img: U("1549465220-1a8b9238cd48") },
  { slug: "congratulations", name: "Congratulations", img: P("14107") },
  { slug: "get-well-soon", name: "Get Well Soon", img: U("1490750967868-88aa4486c946") },
  { slug: "farewell", name: "Farewell", img: U("1513201099705-a9746e1e201f") },
  { slug: "welcome", name: "Welcome", img: U("1513885535751-8b9238bd345a") },
  { slug: "just-because", name: "Just Because", img: U("1549465220-1a8b9238cd48") },
  { slug: "sorry", name: "Sorry", img: U("1490750967868-88aa4486c946") },
  { slug: "i-miss-you", name: "I Miss You", img: U("1518199266791-5375a83190b7") },
];

export const RECIPIENTS = [
  { slug: "for-him", name: "For Him", img: U("1547996160-81dfa63595aa") },
  { slug: "for-her", name: "For Her", img: U("1524592094714-0f0654e20314") },
  { slug: "for-husband", name: "For Husband", img: U("1524805444758-089113d48a6d") },
  { slug: "for-wife", name: "For Wife", img: U("1519741497674-611481863552") },
  { slug: "for-girlfriend", name: "For Girlfriend", img: U("1513885535751-8b9238bd345a") },
  { slug: "for-boyfriend", name: "For Boyfriend", img: U("1547996160-81dfa63595aa") },
  { slug: "for-father", name: "For Father", img: U("1434056886845-dac89ffe9b56") },
  { slug: "for-mother", name: "For Mother", img: U("1524592094714-0f0654e20314") },
  { slug: "for-parents", name: "For Parents", img: U("1513201099705-a9746e1e201f") },
  { slug: "for-brother", name: "For Brother", img: U("1547996160-81dfa63595aa") },
  { slug: "for-sister", name: "For Sister", img: U("1549465220-1a8b9238cd48") },
  { slug: "for-friends", name: "For Friends", img: P("14107") },
  { slug: "for-kids", name: "For Kids", img: U("1464349153735-7db50ed83c84") },
  { slug: "for-colleagues", name: "For Colleagues", img: U("1607083206869-4c7672e72a8a") },
];

export const CATEGORIES = [
  { slug: "watches", name: "Premium Watches", img: U("1541778480-fc1752bbc2a9") },
  { slug: "dry-fruits", name: "Dry Fruit Hampers", img: P("20699854") },
  { slug: "gift-hampers", name: "Gift Hampers", img: U("1549465220-1a8b9238cd48") },
  { slug: "personalized", name: "Personalized Gifts", img: U("1514222709107-a180c68d72b4") },
];

export const label = (slug) =>
  slug.split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

export const findFestival = (s) => FESTIVALS.find((f) => f.slug === s);
export const findOccasion = (s) => OCCASIONS.find((o) => o.slug === s);
export const findRecipient = (s) => RECIPIENTS.find((r) => r.slug === s);
